import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import DashboardLayout from './DashboardLayout';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './AuthContext';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import { HelmetProvider } from 'react-helmet-async';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { PlanSalidaProvider } from './PlanSalida/PlanSalidaContext';

const GOOGLE_CLIENT_ID = "174285649504-c9avu6sdn8klct6o8ggnlar6esimd5ah.apps.googleusercontent.com";

const App: React.FC = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <AuthProvider>
          <PlanSalidaProvider>
            <HelmetProvider>
              <Router>
                <DashboardLayout />
              </Router>
            </HelmetProvider>
          </PlanSalidaProvider>
        </AuthProvider>
      </GoogleOAuthProvider>
      <PWAInstallPrompt />
    </LocalizationProvider>
  );
};

export default App;
